export const getFile = (state, guid) => state.file.files.entries[guid];
